// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"51259bd5b67c9057e594","655":"3b632b7048d9abca4ecd"}[chunkId] + ".js";
};